import React from 'react';
import { LETTER_PLACEHOLDER_DRAG_TYPE, LETTER_PLACEHOLDER_ITEMS } from '../../utils/letterPlaceholderConfig';
import './LetterTemplatesTab.css';

const LetterPlaceholderPalette = ({ onInsert }) => (
  <div className="letter-template-palette">
    <div className="letter-template-palette-title">Placeholders</div>
    <p className="letter-template-palette-hint">
      Drag onto a field below, or click to insert into the last focused field.
    </p>
    <div className="letter-template-palette-chips">
      {LETTER_PLACEHOLDER_ITEMS.map((item) => (
        <button
          key={item.token}
          type="button"
          className="letter-template-chip"
          draggable
          title={item.description}
          onDragStart={(e) => {
            e.dataTransfer.setData(LETTER_PLACEHOLDER_DRAG_TYPE, item.token);
            e.dataTransfer.setData('text/plain', item.token);
            e.dataTransfer.effectAllowed = 'copy';
          }}
          onClick={() => onInsert(item.token)}
        >
          {item.label}
        </button>
      ))}
    </div>
  </div>
);

export default LetterPlaceholderPalette;
